<template>
  <div class="card overflow-hidden">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Card.vue